import { Injectable } from '@angular/core';
import { Observable, of, BehaviorSubject, Subject } from 'rxjs';
import { ILanguage } from './language.model';
import { MIHttpClientService } from 'src/app/shared/mi-http-client.service';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private languagesCache: { [organizationId: string]: ILanguage[] } = JSON.parse(localStorage.getItem('languagesCache')) || {};
  private languagesSubject: Subject<ILanguage[]> = new BehaviorSubject<ILanguage[]>(null);

  constructor(
    private miClient: MIHttpClientService,
  ) { }

  private fetchLanguages(): Observable<ILanguage[]> {
    return this.miClient.get<ILanguage[]>('languages')
      .pipe(tap((langs: ILanguage[]) => this.languagesCache[this.getOrgId()] = langs));
  }

  public getLanguages(): Observable<ILanguage[]> {
    const orgId = this.getOrgId();

    let languages: Observable<ILanguage[]>;

    if (this.languagesCache[orgId]) {
      languages = of(this.languagesCache[orgId]);
    } else {
      languages = this.fetchLanguages();
    }

    return languages.pipe(
      tap((langs: ILanguage[]) => this.languagesSubject.next(langs)),
      tap(() => localStorage.setItem('languagesCache', JSON.stringify(this.languagesCache)))
    );
  }

  private getOrgId(): string {
    return localStorage.getItem('selectedOrganization');
  }

}
